<template>
  <div @click.stop.prevent="toggleChecked" class="checkbox-wrapper">
    <input v-model="checked" :id="name" :name="name" :required="isRequired" v-bind="attrs" class="grp-checkbox-main" />

    <div :class="['checkbox', { 'checkbox-selected': checked, 'checkbox-error': !!errorMessage }]">
      <slot v-if="checked && hasCustomCheckedImage" name="custom-checked-image"></slot>
      <img v-else-if="checked" src="@/assets/img/checked-green.svg" alt="Ícone de check" />
    </div>

    <BaseLabel :for-name="name" :label="label" class="checkbox-label" />
  </div>
</template>

<script>
import { computed, useSlots, toRefs } from 'vue';
import { useField } from 'vee-validate';
import BaseLabel from '@/components/BaseLabel';

export default {
  name: 'CheckboxInput',
  emits: ['toggleChecked'],
  components: { BaseLabel },
  props: {
    label: { type: Object, required: true },
    name: { type: String, required: true },
    attrs: { type: Object, required: true },
  },
  setup(props, { emit }) {
    const { attrs, name } = toRefs(props);

    const slots = useSlots();
    const rules = props.attrs?.rules || null;

    const { value: checked, errorMessage } = useField(name.value, rules, {
      initialValue: attrs.value?.checked || false,
    });

    const isRequired = computed(() => props.attrs?.rules?.includes('required'));

    const hasCustomCheckedImage = computed(() => Object.keys(slots).some((key) => key === 'custom-checked-image'));

    function toggleChecked() {
      checked.value = !checked.value;
      emit('toggleChecked', checked.value);
    }

    return { checked, errorMessage, isRequired, toggleChecked, hasCustomCheckedImage };
  },
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
}

.grp-checkbox-main {
  width: 0px;
  height: 0px;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  visibility: hidden;
}

.checkbox {
  width: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: transparent;
  border: 1.5px solid $white;
  border-radius: 0.25rem;

  &-icon {
    width: 0.625rem;
    pointer-events: none;
  }

  &-selected {
    border-color: $spirit-stone;
  }

  &-error {
    border-color: $error;
  }

  &-label {
    margin-bottom: 0px;
    margin-left: 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.25rem;
    color: $white;
    cursor: pointer;
    letter-spacing: -0.005em;

    // Override floating label properties
    position: unset !important;
    transform: unset !important;
  }
}
</style>
